// extracted by mini-css-extract-plugin
export var floatingButton = "floatingButton-module--floating-button--8edfe";
export var floatingButton_visible = "floatingButton-module--floating-button_visible--261a9";